import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import { type CalendarApi } from "@fullcalendar/core"
import { Button, Flex, Typography } from "antd"
import React from "react"


const { Title } = Typography

interface CalendarNavigationProps {
  getAPI: () => CalendarApi | null | undefined
  onTodayClick: () => void
  onPrevClick: () => void
  onNextClick: () => void
}

export function CalendarNavigation({
  getAPI,
  onTodayClick,
  onPrevClick,
  onNextClick
}: CalendarNavigationProps) {
  const title = getAPI()?.view?.title || "Loading..."

  return (
    <Flex wrap gap={"middle"} className={"pb-2"} align={"center"}>
      <Flex gap={4} align={"center"}>
        <Button
          type={"text"}
          aria-label={"Previous period"}
          title={"Previous period"}
          icon={<LeftOutlined className={"font-bold stroke-3"} />}
          onClick={onPrevClick}
        />
        <Title className={"mb-0 min-w-max"} level={4}>
          {title}
        </Title>
        <Button
          type={"text"}
          aria-label={"Next period"}
          title={"Next period"}
          icon={<RightOutlined />}
          onClick={onNextClick}
        />
      </Flex>
      <Button className={"font-medium"} onClick={onTodayClick}>
        Today
      </Button>
    </Flex>
  )
}
